var exports = {
  "L": "IncomingCallManager.module__portalRoot___azNFX0",
};

module.exports = exports;
